<agpr-dialog-container
    [id]="id+'Dialog'"
    [showClose]="true"
    [heading]="'Discover.manageDist.header'"
    (close)="closeDialog(null)"
    class="agpr-manageDist-dialog"
    [agprLoading]="loading"
    [agprGlobalLoading]="true"
>
    <div class="agpr-manageDist-lhp">
        <div class="agpr-manageDist-filter">
            <agpr-autocomplete
                #autocomplete
                [id]="id + '.filterTextInput'"
                (clear)="resetDists()"
                labelField="name"
                (searchStringChanged)="filterRows($event)"
                [clearOnBlur]="false"
                placeholder="Discover.manageDist.filterPlaceholder"
                [ariaLabel]="'Discover.manageDist.searchDistributions'"
            >
            </agpr-autocomplete>
        </div>
        <agpr-scroll-panel class="agpr-manageDist-scrollpanel">
            <agpr-table
                id="manageDistTable"
                class="agpr-manageDist-table"
                [columns]="columnDefs"
                [sortColumn]="nameColumn"
                [showDelete]="false"
                [sortAscending]="true"
                [(ngModel)]="filteredRows"
                (itemChanged)="selectionChanged($event)"
                (allSelectedChanged)="selectAll($event)"
                [vsItemSize]="37"
                [vsMinBufferPx]="500"
                [vsMaxBufferPx]="500"
            ></agpr-table>
        </agpr-scroll-panel>
    </div>
    <div *ngIf="focusedEntity" class="agpr-manageDist-rhp">
        <div class="agpr-manageDist-profile">
            <div class="agpr-manageDist-profile-thumbnail">
                <img
                    class="agpr-manageDist-profile-thumbnail-img"
                    [agprImageSrc]="focusedEntity.avatarUrl"
                    alt=""
                    [agprDefaultImage]="imageDefault[focusedEntity.entityType]"
                />
            </div>

            <div class="agpr-manageDist-profile-description-container">
                <div class="agpr-manageDist-profile-description">
                    <div *ngIf="focusedEntity.entityType === entityTypes.CONTACT">
                        <div
                            class="agpr-manageDist-profile-description-name agpr-manageDist-overflowEllipse"
                        >
                            {{focusedEntity.firstName}} {{focusedEntity.lastName}}
                        </div>
                        <div
                            *ngIf="focusedEntity.selectedEmployment"
                            class="agpr-manageDist-profile-description-jobtitle agpr-manageDist-overflowEllipse"
                        >
                            {{focusedEntity.selectedEmployment?.jobTitle}}
                        </div>
                        <div
                            *ngIf="focusedEntity.selectedEmployment?.outlet?.name"
                        >
                            {{focusedEntity.selectedEmployment.outlet.name}}
                        </div>
                    </div>

                    <div *ngIf="focusedEntity.entityType === entityTypes.OUTLET">
                        <div class="agpr-manageDist-profile-description-name agpr-manageDist-overflowEllipse">
                            {{focusedEntity?.name}}
                        </div>
                        <div
                            *ngIf="focusedEntity?.mediaTypes.length > 0"
                            class="agpr-manageDist-profile-description-jobtitle"
                        >
                            <span
                                *ngFor="let mediaType of focusedEntity?.mediaTypes; let last = last"
                            >
                                {{ mediaType.displayString | localize }}{{ !last ? ', ' : ''}}
                            </span>
                        </div>
                        <div *ngIf="focusedEntity?.coverageFocus">
                            {{focusedEntity?.coverageFocus.displayString}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <agpr-scroll-panel class="agpr-manageDist-distributionSummary">
            <agpr-chip-container
                class="agpr-manageDist-chipContainer"
                [id]="id + '.distributionSummary'"
                [chips]="distSummaryChips"
                [plainMode]="true"
                (removeChip)="removeChip($event)"
            ></agpr-chip-container>
            <agpr-message
                *ngIf="distSummaryChips.length === 0"
                class="agpr-manageDist-distributionSummary-noContent"
                [severity]="messageSeverityEnum.noContent"
            >
                {{ 'Discover.manageDist.distributionSummary.noContent' | localize }}
            </agpr-message>
        </agpr-scroll-panel>
        <agpr-message
            *ngIf="addedDist.length || removedDist.length"
            class="agpr-manageDist-changeReceipt"
            [severity]="messageSeverityEnum.info"
            [id]="id + '.changeReceipt'"
        >
            <div
                *ngIf="addedDist.length > 0"
                class="agpr-manageDist-changeReceipt-title"
            >
                {{ 'Discover.manageDist.changeReceipt.add' | localize}}
            </div>
            <div
                *ngIf="addedDist.length > 0"
                class="agpr-manageDist-changeReceipt-content"
                tooltipStyleClass="agpr-manageDist-changeReceipt-info-tooltip"
                [pTooltip]="('Discover.manageDist.changeReceipt.add' | localize) + '\n' + (addedDist | joinList)"
                tooltipPosition="top"
            >
                <span
                    *ngFor="let dist of addedDist; let last = last"
                >
                    {{ dist | localize }}{{ !last ? ', ' : ''}}
                </span>
            </div>

            <div
                *ngIf="removedDist.length > 0"
                class="agpr-manageDist-changeReceipt-title"
            >
                {{ 'Discover.manageDist.changeReceipt.remove' | localize}}
            </div>
            <div
                *ngIf="removedDist.length > 0"
                class="agpr-manageDist-changeReceipt-content"
                tooltipStyleClass="agpr-manageDist-changeReceipt-info-tooltip"
                [pTooltip]="('Discover.manageDist.changeReceipt.remove' | localize) + '\n' + (removedDist | joinList)"
                tooltipPosition="top"
            >
                <span
                    *ngFor="let dist of removedDist; let last = last"
                >
                    {{ dist | localize }}{{ !last ? ', ' : ''}}
                </span>
            </div>
        </agpr-message>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            [label]="'cancel' | localize"
            [style]="buttonTypes.secondary"
            (click)="closeDialog(null)"
        >
        </agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [style]="buttonTypes.primary"
            [label]="'Discover.manageDist.updateButton' | localize"
            [disabled]="!addedDist.length && !removedDist.length"
            (click)="updateDists()"
        >
        </agpr-button>
    </ng-template>
</agpr-dialog-container>

<ng-template let-row="row" let-column="column" #countInfoCell>
    <div class="agpr-manageDist-table-row">
        <label
            *ngIf="row.count !== null && !row.countLoading"
            class="agpr-manageDist-table-label"
        >
            {{row.count}}
        </label>
        <span>
            <span
                *ngIf="row.modifiedUser"
                role="img"
                class="fa-regular fa-circle-info agpr-manageDist-infoCircle"
                [agprTooltip]="'Tags.manageDialog.tagGroupInformation' | localize : {
                    createdDate: row.createdDate,
                    createdBy: row.createdUser,
                    modifiedDate: row.modifiedDate,
                    modifiedBy: row.modifiedUser
                }"
                [initiallyFocusable]="false"
            ></span>
            <span
                *ngIf="!row.modifiedUser"
                role="img"
                class="fa-regular fa-circle-info agpr-manageDist-infoCircle"
                [agprTooltip]="'Tags.manageDialog.tagGroupInformation.unmodified' | localize : {
                    createdDate: row.createdDate,
                    createdBy: row.createdUser
                }"
                [initiallyFocusable]="false"
            ></span>
        </span>
    </div>
</ng-template>
